import React, { useState, useEffect } from "react";
import "./navbar.css";
import "../../CSS/cart.css";
import Logo from "../../Images/storeLogo.png";
import img from "../../Images/default.png";
import { GrClose } from "react-icons/gr";
import { RiShoppingBag3Fill } from "react-icons/ri";
import { FiSearch } from "react-icons/fi";
import { FiMenu } from "react-icons/fi";
import { RxCross1 } from "react-icons/rx";
import { useLocation, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setCart } from "../../store/cartSlice";

function Navbar() {
  const { data, url } = useSelector((state) => state.product);
  const { cart } = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  const location = useLocation();
  const currentPath = location.pathname;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCartopen, setIsCartOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const openCart = () => {
    setIsCartOpen(true);
  };
  const closeCart = () => {
    setIsCartOpen(false);
  };

  const handleRemove = (idToDelete) => {
    const products = JSON.parse(localStorage.getItem(url));
    const indexToDelete = products.findIndex(
      (product) => product._id === idToDelete
    );

    if (indexToDelete !== -1) {
      products.splice(indexToDelete, 1);
      localStorage.setItem(url, JSON.stringify(products));
      dispatch(setCart(JSON.parse(localStorage.getItem(url))));
      alert("Product deleted successfully.");
    }
  };

  useEffect(() => {
    let cart = JSON.parse(localStorage.getItem(url));
    if (!cart) {
      cart = [];
    }
    localStorage.setItem(url, JSON.stringify(cart));
    dispatch(setCart(JSON.parse(localStorage.getItem(url))));
  }, [dispatch, url]);

  return (
    <div>
      {data.status === "offline" ? (
        <div className="offline-card">
          <h4>
            Oops! Our store is currently offline for a little break, but we'll
            be back soon with amazing deals and products. Thanks for your
            patience!
          </h4>
        </div>
      ) : null}
      <div className="container">
        {/* ! logo and store title section */}
        <section className="logo-title-section">
          <div className="logo">
            <img
              src={
                data.storeDetails && data.storeDetails[0].logo
                  ? `${process.env.REACT_APP_LOGO_IMAGE_PATH}${data.storeDetails[0].logo}`
                  : Logo
              }
              alt="store-logo"
            />
          </div>
          <div className="title">
            <h2 className="title-text">{data.businessName}</h2>
          </div>
        </section>

        {/* ------------------------------Navbar------------------------- */}
        <section className="navbar-section">
          <nav className="navbar">
            <div className="menu">
              <FiMenu className="fa-bars" id="icon" onClick={openModal} />
            </div>
            <ul className="nav-list">
              <li
                className={`nav-item ${
                  currentPath === `/${url}` ? "active" : ""
                }`}
              >
                <Link to={`/${url}`}>HOME</Link>
              </li>
              <li
                className={`nav-item ${
                  currentPath === `/${url}/about` ? "active" : ""
                }`}
              >
                <Link to={`/${url}/about`}>ABOUT</Link>
              </li>
              <li
                className={`nav-item ${
                  currentPath === `/${url}/contact` ? "active" : ""
                }`}
              >
                <Link to={`/${url}/contact`}>CONTACT</Link>
              </li>
            </ul>
          </nav>
          <div className="search-bag-container">
            <Link to={`/${url}/search`}>
              <FiSearch id="icon" color="#041c27" />
            </Link>
            <div className="cart-container">
              <div className="cart-badge">{cart.length}</div>
              <RiShoppingBag3Fill
                id="icon"
                color="#041c27"
                onClick={openCart}
              />
            </div>
          </div>
        </section>
        {isModalOpen && (
          <section className="navbar-overlay-container">
            <RxCross1 className="fa-xmark" id="x-icon" onClick={closeModal} />
            <div className="modal">
              <ul className="modal-nav-links">
                <li className={currentPath === `/${url}` ? "active" : ""}>
                  <Link to={`/${url}`}>HOME</Link>
                </li>
                <li className={currentPath === `/${url}/about` ? "active" : ""}>
                  <Link to={`/${url}/about`}>ABOUT</Link>
                </li>
                <li
                  className={currentPath === `/${url}/contact` ? "active" : ""}
                >
                  <Link to={`/${url}/contact`}>CONTACT</Link>
                </li>
              </ul>
            </div>
          </section>
        )}
      </div>
      {/* -------------------------cart---------------------- */}
      {isCartopen && (
        <div>
          <div className="main-cart-container">
            <div className="cart-container1">
              <div className="cart-header1">
                <div className="cart-title">Cart</div>
                <GrClose className="close-button" onClick={closeCart} />
              </div>
              <div className="cart-product-list">
                {cart.map((product, index) => (
                  <div className="cart-product-card" key={index} >
                    <div className="cart-product-image">
                      <img
                        src={
                          product.images.length > 0
                            ? `${process.env.REACT_APP_PRODUCT_IMAGE_PATH}${product.images[0]}`
                            : img
                        }
                        alt="Product"
                      />
                    </div>
                    <div className="cart-product-details">
                      <div className="cart-product-name">
                        {product.productName}
                      </div>
                      <div className="cart-product-price">
                        <span className="cart-selling-price">
                          ₹{product.sellingPrice}
                        </span>
                        <span className="cart-mrp-price">₹{product.MRP}</span>
                        <span className="cart-discount">
                          {(
                            ((product.MRP - product.sellingPrice) /
                              product.MRP) *
                            100
                          ).toFixed(2)}
                          % Off
                        </span>
                      </div>
                      <div
                        className="delete-button"
                        onClick={() => handleRemove(product._id)}
                      >
                        Delete
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Navbar;
